import { User } from "../../../api/userApi";

const getUserState = (user: User): "inactive" | "active" | "expired" => {
  if (!user?.paid) return "inactive";

  // paid가 true면 start_dt, end_dt로 active/expired 판단
  const now = new Date();
  if (user.end_dt) {
    const endDate = new Date(user.end_dt);
    return now > endDate ? "expired" : "active";
  }

  return "active";
};

export default getUserState;
